
import { defineComponent } from 'vue';


export default defineComponent({
  name: 'Cronometer',
  props: {
    timeInSeconds: {
      type: Number,
      default: 0
    }
  },
  computed: {
    elapsedTime(): string {
      return new Date(this.timeInSeconds * 1000).toISOString().substring(11,19);
    }
  }
});
